import React, { useCallback, useState } from "react";
import { SendRequest } from "../../util/AxiosUtil";
import GameMonitorTable from "../../components/Tables/GameMonitorTable";
import GamesTable from "../../components/Tables/GamesTable";
const GameMontior = () => {
  const [data, setData] = useState([]);
  const handleClick = useCallback((row, col) => {
    switch (row) {
      case 0:
        SendRequest({
          url: "Admin/get-games-by-period",
          method: "post",
          data: {
            Type: col,
          },
        }).then((result) => {
          setData(result.data);
        });
        break;
      default:
        break;
    }
  }, []);
  return (
    <>
      <GameMonitorTable handleClick={handleClick}></GameMonitorTable>
      <hr />
      <GamesTable games={data} />
    </>
  );
};

export default GameMontior;
